import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { Password } from 'ui';
import * as React from 'react';

export const passwordCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods) =>
  <Password
    onChange={fieldMethods.handleChange(props.name)}
    componentId={props.name}
    className={props.className}
    label={fieldMethods.buildLabel(props.label)}
    value={fieldMethods.getProperty(props.name)}
    placeholder={props.placeholder}
    validation={fieldMethods.getValidation(props.name)}
    />;
